import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter as Router} from "react-router-dom";
import {
    BasketProvider,
    MallProvider,
    NavProvider,
    PromptProvider,
    RootProvider,
    SpeechProvider,
    StoreProvider,
    UserProvider
} from "./providers";



const Providers = ({children}) =>{
    return(
        <PromptProvider>
            <BasketProvider>
            <StoreProvider>
            <SpeechProvider>
                <NavProvider>
                    <MallProvider>
                        <UserProvider>
                            <RootProvider>
                                {children}
                            </RootProvider>
                        </UserProvider>
                    </MallProvider>
                </NavProvider>
            </SpeechProvider>
            </StoreProvider>
            </BasketProvider>
        </PromptProvider>
    )
}


ReactDOM.render(
    <Router>
        <Providers>
            <App />
        </Providers>
    </Router>,
    document.getElementById('root')
);


serviceWorker.register();
